import { render } from "./SymptomsForm.vue?vue&type=template&id=57a8d117&scoped=true"
import script from "./SymptomsForm.vue?vue&type=script&lang=js"
export * from "./SymptomsForm.vue?vue&type=script&lang=js"

import "./SymptomsForm.vue?vue&type=style&index=0&id=57a8d117&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a8d117"]])

export default __exports__